export const heroData = {
  tags: ["香蕉视频", "西瓜视频", "蜜桃视频", "樱桃视频"],
  h1: "芭乐视频 - 高清水果视频平台免费在线观看",
  slogan: "每日更新 · 不卡顿 · 全集免费 · 多平台资源聚合",
  intro: "芭乐视频聚合香蕉视频、西瓜视频、蜜桃视频、樱桃视频等主流水果视频平台优质资源，为您提供海量高清电影、电视剧、综艺、动漫免费在线观看。每日同步更新最新剧集，高速服务器确保观影全程不缓冲，是您追剧看片的最佳选择。",
  stats: [
    { label: "每日更新剧集", value: "200+" },
    { label: "覆盖内容品类", value: "15+" },
    { label: "高清流畅播放", value: "1080P" },
  ],
};

export const navItems = [
  { label: "首页", href: "#hero" },
  { label: "移动端入口", href: "#app" },
  { label: "热议话题", href: "#topics" },
  { label: "关于芭乐", href: "#about" },
  { label: "热播榜单", href: "#ranking" },
  { label: "常见问答", href: "#faq" },
];

export const indexItems = [
  { title: "院线大片专区", desc: "最新上映电影高清呈现，同步院线热门影片资源，动作、喜剧、悬疑类型全覆盖", icon: "ri-film-line", color: "primary" },
  { title: "热播电视剧场", desc: "国产剧、韩剧、美剧、日剧一网打尽，追剧日历同步更新，不再错过任何精彩", icon: "ri-tv-line", color: "accent" },
  { title: "综艺娱乐合集", desc: "热门综艺节目完整收录，真人秀、脱口秀、音乐竞演，周末娱乐包你满意", icon: "ri-emotion-laugh-line", color: "secondary" },
  { title: "动漫二次元", desc: "国漫崛起与日漫经典并行，新番速递、经典回顾，二次元爱好者专属频道", icon: "ri-rocket-line", color: "primary" },
  { title: "纪录片精选", desc: "BBC、Discovery、央视纪录精选呈现，自然、历史、科技题材拓宽视野", icon: "ri-earth-line", color: "accent" },
  { title: "儿童专区", desc: "安全健康的儿童内容筛选，寓教于乐的动画与节目，家长放心孩子开心", icon: "ri-heart-line", color: "secondary" },
  { title: "短剧速看", desc: "节奏紧凑的精品短剧，每集十分钟碎片时间轻松追，剧情反转不停歇", icon: "ri-flashlight-line", color: "primary" },
  { title: "经典怀旧", desc: "那些年我们一起追过的剧，经典港剧、老电影回顾，重温青春记忆", icon: "ri-time-line", color: "accent" },
];

export const updateItems = [
  { date: "2026-07-31", title: "「长风渡」全40集已上线，白敬亭宋轶领衔主演古装商战大剧", tag: "新剧上线" },
  { date: "2026-07-30", title: "院线大片「消失的她」高清版独家上线水果视频平台频道", tag: "电影更新" },
  { date: "2026-07-29", title: "「奔跑吧」第十二季最新期上线，本期嘉宾阵容豪华升级", tag: "综艺更新" },
  { date: "2026-07-28", title: "蜜桃视频源「莲花楼」全40集同步更新，成毅武侠力作", tag: "同步更新" },
  { date: "2026-07-27", title: "樱桃视频动漫频道「凡人修仙传」新季开播，国漫再添力作", tag: "动漫上线" },
  { date: "2026-07-26", title: "系统全面升级，播放体验优化，新增4K超清画质选项", tag: "平台公告" },
  { date: "2026-07-25", title: "「庆余年」第二季预热专题上线，回顾第一季精彩名场面", tag: "专题上线" },
  { date: "2026-07-24", title: "水果视频平台韩剧频道「欢迎回到三达里」同步韩国更新", tag: "海外同步" },
];

export const commentItems = [
  { name: "追剧达人小王", avatar: "王", text: "用芭乐视频追剧快一年了，资源真的很全，香蕉视频和西瓜视频上的热剧这里基本都有。画质清晰流畅，关键是免费！推荐给了好多朋友。", rating: 5, time: "2天前" },
  { name: "电影爱好者阿明", avatar: "明", text: "作为一个重度电影迷，芭乐视频的院线大片更新速度让我惊喜。上个月刚下线的电影这里就能看了，省了不少电影票钱。播放不缓冲这点真的赞。", rating: 5, time: "5天前" },
  { name: "宝妈小雨", avatar: "雨", text: "儿童专区的内容筛选做得很好，孩子看的动画片都是健康向上的。每天睡前陪孩子看两集，已经成为我们家的固定节目了。水果视频平台确实好用。", rating: 4, time: "1周前" },
];

export const contactInfo = {
  title: "内容合作与投稿",
  desc: "芭乐视频持续拓展优质内容资源，欢迎内容创作者、版权方、平台运营方与我们建立合作。目前主要合作方向包括：影视内容授权、原创短剧投稿、频道联合运营、广告商务投放等。",
  features: ["版权合作对接", "内容快速上线", "收益分成模式", "流量扶持计划"],
  email: "contact@balevideo.com",
  wechat: "balevideo2026",
};

export const rankingItems = [
  { rank: 1, title: "长风渡", category: "电视剧", heat: "9.8", trend: "up", desc: "古装商战大剧，白敬亭宋轶演绎商场风云" },
  { rank: 2, title: "消失的她", category: "电影", heat: "9.7", trend: "up", desc: "悬疑反转神作，朱一龙倪妮演技炸裂" },
  { rank: 3, title: "莲花楼", category: "电视剧", heat: "9.6", trend: "up", desc: "成毅武侠力作，江湖奇案层层揭开" },
  { rank: 4, title: "奔跑吧·第十二季", category: "综艺", heat: "9.5", trend: "stable", desc: "豪华嘉宾阵容，笑点密集的户外真人秀" },
  { rank: 5, title: "凡人修仙传", category: "动漫", heat: "9.4", trend: "up", desc: "国漫巅峰之作，韩立修仙之路热血开启" },
  { rank: 6, title: "欢迎回到三达里", category: "电视剧", heat: "9.3", trend: "stable", desc: "暖心韩剧，池昌旭申惠善治愈系爱情" },
];

export const mediaItems = [
  { title: "长风渡 · 精彩片段", duration: "03:25", category: "古装商战", desc: "顾九思柳玉茹初次交锋，商场如战场的高能对决" },
  { title: "消失的她 · 悬疑名场面", duration: "02:48", category: "悬疑反转", desc: "何非醒来发现妻子失踪，真相究竟通向何方" },
  { title: "莲花楼 · 武打高光", duration: "04:12", category: "武侠动作", desc: "李莲花独闯敌营，一招一式尽显江湖侠气" },
  { title: "奔跑吧 · 爆笑合集", duration: "05:30", category: "户外综艺", desc: "本期最搞笑的游戏环节，嘉宾们笑到停不下来" },
  { title: "凡人修仙传 · 开篇震撼", duration: "02:15", category: "国漫精品", desc: "韩立初入修仙世界，宏大世界观震撼开启" },
];

export const cardItems = [
  { title: "暑期档必看片单", image: "summer-movies", tag: "专题策划", desc: "这个暑假最值得追的20部高分影视剧，从古装到现代一网打尽" },
  { title: "国产悬疑剧天花板", image: "suspense", tag: "编辑精选", desc: "近两年评分最高的国产悬疑剧TOP10，每一部都让人欲罢不能" },
  { title: "韩剧高分推荐", image: "kdrama", tag: "热门分类", desc: "从浪漫爱情到悬疑犯罪，这些高分韩剧拯救你的剧荒周末" },
  { title: "国漫崛起之路", image: "anime", tag: "深度观察", desc: "盘点近年制作精良的国产动漫，从画风到剧情全面超越日漫" },
  { title: "周末电影马拉松", image: "weekend", tag: "观影指南", desc: "精选6部不同类型的高分电影，完美填满你的周末观影时光" },
  { title: "经典港剧回顾", image: "hk-drama", tag: "怀旧经典", desc: "那些年我们熬夜追的港剧，天龙八部、射雕英雄传等经典重现" },
  { title: "真人秀综艺精选", image: "variety", tag: "娱乐放松", desc: "最下饭的综艺节目清单，从竞技到旅行，总有一款适合你" },
];

export const topicItems = [
  { name: "#长风渡大结局", heat: 1280, posts: "3.2万", trend: "hot" },
  { name: "#消失的她反转", heat: 1150, posts: "2.8万", trend: "hot" },
  { name: "#莲花楼名场面", heat: 980, posts: "2.1万", trend: "rising" },
  { name: "#水果视频平台推荐", heat: 860, posts: "1.9万", trend: "hot" },
  { name: "#暑期追剧清单", heat: 750, posts: "1.6万", trend: "rising" },
  { name: "#香蕉视频资源", heat: 690, posts: "1.5万", trend: "stable" },
  { name: "#国漫凡人修仙传", heat: 620, posts: "1.3万", trend: "rising" },
  { name: "#西瓜视频同款", heat: 580, posts: "1.2万", trend: "stable" },
  { name: "#蜜桃视频新剧", heat: 520, posts: "1.1万", trend: "rising" },
];

export const carouselItems = [
  {
    title: "长风渡 · 古装商战巅峰",
    desc: "白敬亭、宋轶领衔主演，江南首富之女与纨绔子弟的商场情场双重较量，权谋与爱情的交织让人欲罢不能",
    tag: "热度榜首",
    color: "from-primary",
    image: "changfengdu",
  },
  {
    title: "暑期档 · 水果视频平台片单",
    desc: "整合香蕉视频、西瓜视频、蜜桃视频、樱桃视频等平台暑期热门资源，一站式观影追剧新体验，这个夏天精彩不停",
    tag: "编辑力荐",
    color: "from-accent",
    image: "summer-lineup",
  },
  {
    title: "悬疑剧场 · 烧脑不停",
    desc: "消失的她、隐秘的角落、沉默的真相……精选高分悬疑片单，每一部都让你猜不到结局，准备好迎接反转了吗",
    tag: "专题合集",
    color: "from-primary",
    image: "mystery",
  },
  {
    title: "国漫崛起 · 凡人修仙传",
    desc: "制作精良的国产动漫新标杆，宏大修仙世界观搭配顶级3D画面，每周更新引发全网讨论，国漫爱好者不容错过",
    tag: "国漫之光",
    color: "from-accent",
    image: "fanren",
  },
];

export const appInfo = {
  title: "随时随地 · 畅享观影",
  desc: "芭乐视频移动端适配完美，无需下载安装，浏览器打开即可畅享高清视频。支持 iOS、Android 所有主流设备，横屏竖屏自动适配，数据流量智能优化，让您随时随地享受流畅观影体验。",
  features: ["无需安装", "全设备适配", "流量优化", "画质自适应"],
};

export const aboutInfo = {
  title: "关于芭乐视频",
  desc1: "芭乐视频是一个聚合型高清视频在线观看平台，致力于为用户提供丰富、便捷、免费的观影体验。平台整合了香蕉视频、西瓜视频、蜜桃视频、樱桃视频等主流水果视频平台优质资源，涵盖电影、电视剧、综艺、动漫、纪录片等多品类内容。",
  desc2: "我们坚持每日更新最新剧集，采用先进的视频分发技术确保播放流畅不缓冲，支持1080P高清画质。无论是追热播剧、看院线大片，还是重温经典老片，芭乐视频都是您值得信赖的水果视频平台。",
  stats: [
    { value: "5万+", label: "影视资源" },
    { value: "200+", label: "日更新量" },
    { value: "500万+", label: "月活用户" },
    { value: "15+", label: "内容品类" },
  ],
};

export const faqItems = [
  {
    q: "芭乐视频是否需要注册才能观看？",
    a: "不需要。芭乐视频目前所有内容均免费开放观看，无需注册或登录，打开网站即可直接选择喜欢的电影电视剧进行观看，真正做到无门槛观影体验。",
  },
  {
    q: "芭乐视频和香蕉视频、西瓜视频是什么关系？",
    a: "芭乐视频是一个独立的水果视频聚合平台，整合了香蕉视频、西瓜视频、蜜桃视频、樱桃视频等平台优质影视资源，为用户提供一站式的观影入口。我们并非任何平台的替代品，而是资源聚合服务方。",
  },
  {
    q: "播放过程中会不会卡顿？需要缓冲很久吗？",
    a: "芭乐视频采用先进的CDN加速和视频分发技术，多数用户在高清模式下也可实现流畅播放。如遇卡顿，建议检查网络状况或尝试切换清晰度。我们持续优化服务器性能以保障观影体验。",
  },
  {
    q: "更新速度怎么样？最新剧集多久能看？",
    a: "芭乐视频每日同步更新最新剧集资源，热门剧集通常在播出后数小时内即可在平台观看。每日更新量超过200部/集，覆盖电视剧、电影、综艺、动漫等全部品类。",
  },
  {
    q: "可以在手机上观看吗？需要下载APP吗？",
    a: "可以。芭乐视频完美适配手机浏览器访问，无需下载任何APP。iOS和Android设备均可流畅播放，支持横屏全屏观看，自动适配不同屏幕尺寸，流量消耗也经过智能优化。",
  },
];

export const featureItems = [
  {
    icon: "ri-movie-line",
    title: "海量资源库",
    desc: "聚合香蕉视频、西瓜视频、蜜桃视频、樱桃视频等平台内容，电影电视剧综艺动漫纪录片一网打尽，总量超5万部。",
  },
  {
    icon: "ri-speed-up-line",
    title: "极速不缓冲",
    desc: "自建CDN加速节点覆盖全国，智能码率自适应技术确保不同网络环境下都能流畅播放，告别加载等待。",
  },
  {
    icon: "ri-smartphone-line",
    title: "全端适配",
    desc: "PC、平板、手机全终端完美适配，无需安装任何软件或插件，浏览器打开即看，随时随地享受观影乐趣。",
  },
  {
    icon: "ri-refresh-line",
    title: "每日更新",
    desc: "专业运营团队7×24小时监控更新，热门剧集播出后数小时内同步上线，让你永远走在追剧最前沿。",
  },
];